<div class="match-parent">
  <div class="map" id="map"></div>
</div>
<div class="changemap">
  <button type="button" class="btn btn-primary btn-sm" (click)="onChangeStyle()">{{buttonText}}</button>
</div>

